<template>
  <div id="app">
    <div id="content">
      <div id="background">
        <div id="curtain-left" />
        <div id="curtain-right" />
        <div id="curtain-top" />
        <div id="curtain-bottom-left" />
        <div id="curtain-bottom-right" />
      </div>

      <div id="top-bar-mobile" class="mobile">
        <router-link @click.native="onTabClicked" id="logo-small" to="/" ><span /></router-link>
        <div id="menu" @click="onMenuClicked" />
      </div>

      <div id="tab-bar" v-show="showTabBar">
        <router-link class="tab" id="logo-top" to="/" />
        <div id="item-list">
          <router-link @click.native="onTabClicked" to="/about" class="tab">
            {{ $t('tabBar.aboutUs')}}
          </router-link>

          <router-link @click.native="onTabClicked" to="/activities" class="tab">
            {{ $t('tabBar.activities')}}
          </router-link>

          <router-link @click.native="onTabClicked" to="/service" class="tab">
            {{ $t('tabBar.service')}}
          </router-link>

          <router-link class="tab" id="logo" to="/" ><span /></router-link>

          <router-link @click.native="onTabClicked" to="/album" class="tab">
            {{ $t('tabBar.album')}}
          </router-link>
          <router-link  @click.native="onTabClicked" to="/contact" class="tab">
            {{ $t('tabBar.contactUs')}}
          </router-link>
          <a class="tab" id="fb" href="https://www.facebook.com/%E6%88%B2%E5%83%8F%E5%AD%B8%E5%A0%82-%E5%9C%8B%E9%9A%9B-111310671686911/" target="_blank">
            {{ $t('tabBar.facebook')}}
          </a>
        </div>
      </div>

      <router-view id="router-view" />
    </div>

    <div id="footer" class="font-semibold">
      {{ $t('layout.copyright')}}
    </div>
  </div>
</template>

<script>
  export default {
    name: 'app',
    data() {
      return {
        showTabBar: false,
      };
    },
    methods: {
      onMenuClicked() {
        this.showTabBar = !this.showTabBar;
      },
      onTabClicked(e) {
        this.showTabBar = false;
        e.preventDefault();
        e.stopPropagation();
      },
    },
  };
</script>

<style lang="sass">
  @import "./styles/font.sass"
  $body-weight: 500

  @import "../node_modules/bulma/bulma.sass"
  @import "../node_modules/swiper/dist/css/swiper.css"
</style>

<style lang="sass">
  @import "./styles/variables.sass"

  html, body
    height: 100%

  html
    overflow-y: scroll
    overflow-x: hidden
    -webkit-overflow-scrolling: touch

  .font-semibold
    font-family: PingFangTC-Semibold

  @media #{$desktop}
    .mobile
      display: none !important

  @media #{$mobile}
    .desktop
      display: none !important

</style>

<style lang="sass" scoped>
  @import "./styles/variables.sass"

  #app
    height: 100%

  #content
    min-height: 100%
    margin-bottom: -58px
    position: relative

    @media #{$desktop}
      padding: 40px 0 58px 0

    @media #{$mobile}
      padding: 15px 0px 58px 0px

    #background
      position: absolute
      top: 0
      bottom: 0
      left: 0
      right: 0
      z-index: -1
      overflow: hidden
      background-color: $ecru-white

      @media #{$desktop}
        #curtain-left
          background-image: url(../static/curtain-left.png)
          top: 0
          left: 0
          width: 145px
          height: 683px
          background-size: 145px 683px
          position: absolute

        #curtain-top
          background-image: url(../static/curtain-top.png)
          top: 0
          left: 0
          right: 0
          height: 29px
          background-size: 760px 29px
          position: absolute

        #curtain-right
          background-image: url(../static/curtain-right.png)
          top: 0
          right: 0
          width: 144px
          height: 683px
          background-size: 144px 683px
          position: absolute

        #curtain-bottom-left
          background-image: url(../static/curtain-bottom-left.png)
          top: 683px
          bottom: 0
          left: 0
          width: 73px
          background-size: 73px 1px
          position: absolute

        #curtain-bottom-right
          background-image: url(../static/curtain-bottom-right.png)
          top: 683px
          bottom: 0
          right: 0
          width: 72px
          background-size: 72px 1px
          position: absolute

      @media #{$mobile}
        #curtain-top
          background-image: url(../static/curtain-small.png)
          top: 0
          left: 0
          right: 0
          height: 13px
          background-size: 678px 13px
          position: absolute

  #footer
    background-color: $russett
    color: $white
    text-align: center
    font-size: 16px
    height: 58px
    line-height: 58px

    @media #{$mobile}
      font-size: 12px

  #tab-bar
    @media #{$mobile}
      background-color: $jaffa
      position: absolute
      left: 0
      right: 0
      top: 78px
      padding: 22px 28px
      padding-bottom: 10px
      z-index: 2

    @media #{$desktop}
      display: block !important

    #logo-top
      display: none

      @media screen and (max-width: 900px)
        background-image: url(../static/logo.png)
        width: 150px
        height: 128px
        background-size: 150px 128px
        display: block
        margin: 0 auto
        margin-bottom: 20px

      @media #{$mobile}
        display: none

    #item-list
      display: flex;
      justify-content: center

      @media screen and (min-width: 901px)
        padding-top: 70px

      @media #{$mobile}
        flex-flow: column

      .tab
        color: $gray
        font-size: 18px
        padding: 12px
        height: 55px
        white-space: nowrap

        @media #{$desktop}
          &:not(:last-child)
            border-right: 1px dashed $olivine

          &.router-link-active
            border-bottom: 3px solid $jaffa

        @media #{$mobile}
          color: $white
          &:not(:last-child)
            border-bottom: 1px solid rgba(255, 255, 255, 0.5)

          &.router-link-active
            color: $ripe-lemon

      #logo
        padding: 12px 23px
        @media screen and (max-width: 900px)
          display: none

        &.router-link-active
          border-bottom: 3px solid transparent

        span
          background-image: url(../static/logo.png)
          width: 150px
          height: 128px
          background-size: 150px 128px
          display: inline-block;
          margin-top: -83px;

  #top-bar-mobile
    display: flex
    justify-content: space-between
    height: 60px
    align-items: center
    padding: 0 15px

    #logo-small
      background-image: url(../static/logo-small.png)
      width: 114px
      height: 37px
      background-size: 114px 37px

    #menu
      background-image: url(../static/menu-icon.png)
      width: 45px
      height: 36px
      background-size: 45px 36px
      cursor: pointer

  #fb .fa
    vertical-align: middle
    margin-bottom: 4px

</style>



// WEBPACK FOOTER //
// src/App.vue